/**
 * Daily 사진 목에서 사진 id 로 파일 하나를 고르는 규칙.
 *
 * 목 handler(브라우저)와 vite 미들웨어(node)가 **같은 규칙으로** 골라야 한다 — 한쪽만
 * 바뀌면 service worker 가 있는 환경과 없는 환경에서 같은 사진이 다르게 나온다.
 *
 * 그래서 여기서는 파일 **이름만** 다루고 asset 을 import 하지 않는다. vite.config.ts 는
 * node 에서 돌아 `.jpg` import 를 풀지 못하기 때문이다. 이름 → 실제 URL 로 잇는 일은
 * 브라우저 쪽(→ data/dailyPhotos.ts)이 맡는다.
 */
export const DAILY_PHOTO_DIR = "src/mocks/assets/daily";

export const DAILY_PHOTO_FILES = [
  "site-1.jpg",
  "site-2.jpg",
  "site-3.jpg",
  "site-4.jpg",
  "site-5.jpg",
  // 사무소 포트폴리오 사진 18장 — lifethings.in 첫 화면(upload/*.jpg)을 1200px 로 줄여 옮긴 것.
  "site-6.jpg",
  "site-7.jpg",
  "site-8.jpg",
  "site-9.jpg",
  "site-10.jpg",
  "site-11.jpg",
  "site-12.jpg",
  "site-13.jpg",
  "site-14.jpg",
  "site-15.jpg",
  "site-16.jpg",
  "site-17.jpg",
  "site-18.jpg",
  "site-19.jpg",
  "site-20.jpg",
  "site-21.jpg",
  "site-22.jpg",
  "site-23.jpg",
] as const;

/** 같은 사진 id 는 어디서 열어도 늘 같은 그림이다. */
export const dailyPhotoFile = (imageId: string): string => {
  let hash = 0;
  for (const char of imageId) hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
  return DAILY_PHOTO_FILES[hash % DAILY_PHOTO_FILES.length];
};
